import { render } from "./NotificationWrapper.vue?vue&type=template&id=0b5b31e6&lang=pug"
import script from "./NotificationWrapper.vue?vue&type=script&lang=js"
export * from "./NotificationWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/notification/NotificationWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b5b31e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b5b31e6', __exports__)) {
    api.reload('0b5b31e6', __exports__)
  }
  
  module.hot.accept("./NotificationWrapper.vue?vue&type=template&id=0b5b31e6&lang=pug", () => {
    api.rerender('0b5b31e6', render)
  })

}


export default __exports__